import { render, staticRenderFns } from "./affiliateCommissionManage.vue?vue&type=template&id=7a18a940&scoped=true"
import script from "./affiliateCommissionManage.vue?vue&type=script&lang=js"
export * from "./affiliateCommissionManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateCommissionManage.vue?vue&type=style&index=0&id=7a18a940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a18a940",
  null
  
)

export default component.exports